"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepOmit = void 0;
/**
 * @summary Function to remove properties from nested objects.
 *
 * Function to remove properties from nested objects.
 *
 * @param {object|array} obj
 * @param {string|number} property
 * @returns {object|array}
 *
 * @example
 * const inputData = deepOmit(queryData, '__typename');
 */
function deepOmit(obj, property) {
    if (Array.isArray(obj)) {
        return obj.map((item) => deepOmit(item, property));
    }
    else if (obj instanceof Date) {
        return obj;
    }
    else if (obj != null && typeof obj === 'object') {
        return Object.entries(obj)
            .filter(([key]) => key !== property)
            .reduce((previous, [key, value]) => ({
            ...previous,
            [key]: deepOmit(value, property),
        }), {});
    }
    return obj;
}
exports.deepOmit = deepOmit;
